import React from 'react'
import { Link } from 'react-router-dom'
import MobileMenu from '../MobileMenu/MobileMenu'
import Services from '../../api/Services';



const ClickHandler = () => {
    window.scrollTo(10, 0);
}
const Header = (props) => {

    // const [menuActive, setMenuState] = useState(false);

    // const SubmitHandler = (e) => {
    //     e.preventDefault()
    // }




    return (
        <header id="header">
            <div className={"" + props.hclass} >
                <nav className="navigation navbar navbar-expand-lg navbar-light">
                    <div className="container-fluid">
                        <div className="row align-items-center g-0">
                            <div className={"" + props.col1}>
                                <div className="mobail-menu">
                                    <MobileMenu />
                                </div>
                            </div>
                            <div className={"" + props.col2}>
                                <div className="navbar-header ">
                                    <Link onClick={ClickHandler} className="navbar-brand" to="/home"><img src={props.Logo}
                                        alt="" /></Link>
                                </div>
                            </div>
                            <div className={"" + props.col3}>
                                <div id="navbar" className="collapse navbar-collapse navigation-holder">
                                    <button className="menu-close"><i className="ti-close"></i></button>
                                    <ul className="nav navbar-nav mb-2 mb-lg-0">
                                        {/* <li className="menu-item-has-children image-style-item">
                                            <Link onClick={ClickHandler} to="#">Home</Link>

                                        </li> */}
                                        <li className="menu-item-has-children">
                                            <Link onClick={ClickHandler} to="#">About</Link>
                                            <ul className="sub-menu">
                                                <li><Link onClick={ClickHandler} to="/aboutus">About Us</Link></li>

                                                <li>
                                                    <Link onClick={ClickHandler} to="/our-team">Team</Link>

                                                </li>
                                                <li>
                                                    <Link onClick={ClickHandler} to="/FAQ">FAQ</Link>

                                                </li>

                                            </ul>
                                        </li>
                                        <li className="menu-item-has-children">
                                            <Link onClick={ClickHandler} to="/our-projects">Projects</Link>
                                            <ul className="sub-menu">
                                                <li><Link onClick={ClickHandler} to="/our-projects/ongoing">Ongoing</Link></li>
                                                <li><Link onClick={ClickHandler} to="/our-projects/completed">Completed</Link></li>
                                            </ul>
                                        </li>
                                        <li className="menu-item-has-children">
                                            <Link onClick={ClickHandler} to="/our-services">Services</Link>

                                            <ul className="sub-menu">
                                                {Services.map((service) => (
                                                    <li key={service.Id}>
                                                        <Link
                                                            onClick={ClickHandler}
                                                            to={`/our-services/${service.slug}`}
                                                        >
                                                            {service.title}
                                                        </Link>
                                                    </li>
                                                ))}
                                            </ul>
                                        </li>


                                        <li className="menu-item-has-children">
                                            <Link onClick={ClickHandler} to="/our-blogs">Blog</Link>

                                        </li>
                                        <li className="menu-item-has-children image-style-item">
                                            <Link onClick={ClickHandler} to="/career">Career</Link>

                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className={"" + props.col4}>
                                <div className="header-right">
                                    <div className="close-form">
                                        <Link className="theme-btn" onClick={ClickHandler} to="/contact-us">Contact Now</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </nav>
            </div>
        </header>
    )
}

export default Header;


